import { documentationActions, schedulingTask, screeningAction } from 'src/redux/actions/constant';

const {
  GET_TASK_NOTE_SCHEDULING_REQUEST,
  GET_TASK_NOTE_SCHEDULING_SUCCESS,
  GET_TASK_NOTE_SCHEDULING_FAILURE,
  GET_TASK_NOTE_SCHEDULING_LOADING,
  GET_TASK_NOTE_SCHEDULING_RESET,
} = schedulingTask;

const initialState: object = {
  isGetTaskNote: false,
  response: null,
  loader: false,
};

export const getTherapistTaskNoteReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_TASK_NOTE_SCHEDULING_SUCCESS: {
      return {
        ...state,
        isGetTaskNote: true,
        response: action.payload,
        loader: false,
      };
    }

    case GET_TASK_NOTE_SCHEDULING_FAILURE:
      return {
        ...state,
        isGetTaskNote: false,
        response: action.payload,
        loader: false,
      };

    case GET_TASK_NOTE_SCHEDULING_LOADING:
      return {
        ...state,
        loader: true,
      };

    case GET_TASK_NOTE_SCHEDULING_RESET:
      return initialState;

    default:
      return state;
  }
};
